/* eslint 'consistent-return':0 */
import ValidationFn from '../validation_fn/validation_fn.js';
import Validators from '../validators/validators.js';
import NotFound from '../validation_errors/validator_not_found_error.js';


export default angular.module('BaseClass.validatable.validator',[ValidationFn, Validators, NotFound])
    .factory('BCValidator', function(BCValidationFn, BCvalidators, BCValidatorNotFoundError) {
        function AnonymousValidator(options, name) {
            if (_.isFunction(options.validator)) {
                if (options.message) options.validator.message = options.message;
                return new Validator(options.validator, name);
            }
        }

        function Validator(validationFn, name) {
            if (validationFn.validator)
                return new AnonymousValidator(validationFn, name);
            if (!_.isFunction(validationFn))
                throw new BCValidatorNotFoundError(name);

            this.name = name || validationFn.name;
            this.message = validationFn.message;
            this.configure = function(options) {
                options = defaultOptions.call(this, options);
                if (hasChildren()) return configuredChildren(options);
                return new BCValidationFn(validationFn, _.defaults(options, this));
            };

            var validator = this;
            this.childValidators = {};
            addChildValidators(validationFn.options);
            BCvalidators.register(validator);

            function addChildValidators(options) {
                _.each(options, function(value, key) {
                    if (isValidator(value)) validator.childValidators[key] = value;
                });
            }

            function isValidator(option) {
                return option.constructor.name === 'Validator';
            }

            function hasChildren() {
                return Object.keys(validator.childValidators).length > 0;
            }

            function configuredChildren(options) {
                return _.chain(validator.childValidators)
                    .map(function(childValidator, name) {
                        if (options[name]) return childValidator.configure(options[name]);
                    }).compact().value();
            }

            function defaultOptions(options) {
                if (!_.isObject(options) || _.isArray(options) || _.isFunction(options))
                    options = {value: options, message: this.message};
                if (!_.isUndefined(validationFn.name) && _.isUndefined(options[validationFn.name]))
                    options[validationFn.name] = options.value;
                return options;
            }

        }

        return Validator;
    }).name;
